import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center">
          {/* Image container */}
          <div className="w-full max-w-[900px] rounded-3xl overflow-hidden mb-12 md:mb-16">
            <img
              src="https://readdy.ai/api/search-image?query=Crowd%20of%20people%20gossiping%20and%20whispering%20in%20dramatic%20warm%20lighting%2C%20secretive%20atmosphere%20with%20film%20grain%20texture%2C%20cinematic%20composition%20with%20golden%20and%20amber%20tones%2C%20artistic%20photography%20style%20with%20vintage%20film%20aesthetic%2C%20mysterious%20vibe%20with%20soft%20shadows%20and%20warm%20highlights&width=1800&height=800&seq=cta-section-home&orientation=landscape"
              alt="加入吃瓜社区"
              className="w-full aspect-[2.25/1] object-cover object-center"
            />
          </div>

          {/* Text */}
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-foreground-900 font-heading leading-tight max-w-3xl">
            不想错过<span className="italic font-light text-foreground-400">任何一个瓜？</span>
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-5 max-w-xl leading-relaxed">
            订阅每日大赛黑料网，第一时间获取网红塌房一手爆料
          </p>

          {/* CTA button */}
          <a
            href="#subscribe"
            className="mt-10 px-10 py-4 bg-foreground-900 text-background-50 font-semibold text-base rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即订阅
            <i className="ri-arrow-right-line ml-2"></i>
          </a>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 md:gap-16 mt-16">
            {[
              { number: '50万+', label: '每日读者' },
              { number: '1000+', label: '独家爆料' },
              { number: '99.9%', label: '满意度' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-black text-foreground-900 font-heading">
                  {stat.number}
                </div>
                <div className="text-foreground-500 text-xs md:text-sm mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}